import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded';
import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/** 404 page rendered for unknown routes. */
export function NotFoundPage() {
  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.5,
        px: 3,
        py: 6,
      }}
    >
      <SearchOffRoundedIcon sx={{ fontSize: 64, color: 'text.disabled' }} />
      <Typography variant="h3" component="h1" sx={{ fontWeight: 800 }}>
        404
      </Typography>
      <Typography variant="h6">Page not found</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        The page you are looking for doesn&apos;t exist or has been moved.
      </Typography>
      <Button component={RouterLink} to="/" variant="contained" sx={{ mt: 1 }}>
        Back to home
      </Button>
    </Box>
  );
}
